









import Vue from 'vue';
import { openModal, notify } from 'mycorems-app-shared';
import isGranted from '../authorization/isGranted.js';
import { Document } from '../types';
import { isInfoGathering } from '../document-type';
import SubmitDocumentConfirmModal from './SubmitDocumentConfirmModal.vue';

export default Vue.extend({
  props: {
    document: {
      type: Object as () => Document,
      required: true,
    },
  },
  computed: {
    isInfoGathering(): boolean {
      return isInfoGathering(this.document.documentType);
    },
    label(): string {
      return (this.isInfoGathering) ? 'Submit' : 'Submit for Review';
    },
  },
  methods: {
    submitWithConfirm(): void {
      openModal(SubmitDocumentConfirmModal, {
        document: this.document,
      }).onOk((document: Document) => {
        this.$emit('submitted', document);
        const docTitle = `${this.document.documentType.name} - ${this.document.title}`;
        notify.success(
          `${docTitle} document is ${(this.isInfoGathering) ? 'submitted' : 'submitted for review'}.`,
        );
      });
    },
    isGranted,
  },
});
